module.exports = __webpack_public_path__ + "static/img/lodign.664a4b5.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lodign.gif
// module id = hM9o
// module chunks = 84